// src/utils/municipios.js
export const MUNICIPIOS_REGIAO = [
  { nome: 'Piripiri', lat: -4.288574936616343, lng: -41.793583025803414 }, 
  { nome: 'Brasileira', lat: -4.140024506880486, lng: -41.73452847268002 },
  { nome: 'Pedro II', lat: -4.5055860953401305, lng: -41.52032460212926 },
  { nome: 'Capitão de Campos', lat: -4.518108220217228, lng: -41.91120844520346 },
  { nome: 'Lagoa de São Francisco', lat: -4.332597179102657, lng: -41.583693321929765 },
  { nome: 'Domingos Mourão', lat: -4.269375632996853, lng: -41.35965035329575 },
  { nome: 'Batalha', lat: -3.9900799887396956, lng: -42.098745769592135 },
  { nome: 'Boa Hora', lat: -4.408851043682379, lng: -42.10175174334713 },
  { nome: 'Barras', lat: -4.1930678521374505, lng: -42.42058760369454 },
  { nome: 'Piracuruca', lat: -3.823911009315423, lng: -41.546698377706484 },
  { nome: 'Milton Brandão', lat: -4.6860, lng: -41.4390 },
  { nome: 'São João da Fronteira', lat: -3.9450, lng: -41.2580 },
  { nome: 'São José do Divino', lat: -3.8110, lng: -41.8310 }
];
